/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FareType,
    FareTypeFromJSON,
    FareTypeFromJSONTyped,
    FareTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface FareTypeCriteriaOutput
 */
export interface FareTypeCriteriaOutput {
    /**
     * 
     * @type {boolean}
     * @memberof FareTypeCriteriaOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {FareType}
     * @memberof FareTypeCriteriaOutput
     */
    value?: FareType;
}

export function FareTypeCriteriaOutputFromJSON(json: any): FareTypeCriteriaOutput {
    return FareTypeCriteriaOutputFromJSONTyped(json, false);
}

export function FareTypeCriteriaOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareTypeCriteriaOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : FareTypeFromJSON(json['value']),
    };
}

export function FareTypeCriteriaOutputToJSON(value?: FareTypeCriteriaOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': FareTypeToJSON(value.value),
    };
}


